/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC, useEffect} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../../_metronic/layout/core'
import {getPackageData} from '../redux/PackageCRUD'
import {useDispatch} from 'react-redux'
import * as packages from '../redux/PackageRedux'
import ListPackageData from './ListPackageData'

const ListPage: FC = () => {
  const dispatch = useDispatch()

  const callPackageData = async () => {
    try {
      let locationData = await getPackageData(0, 10)
      if (locationData.data) {
        await dispatch(packages.actions.setPackageLoading(true))
        // once packages data set then loading will automatically off using saga middleware
        await dispatch(packages.actions.setPackageData(locationData.data.docs))
        await dispatch(packages.actions.setPackageDataTotal(locationData.data.totalDocs))
      }
    } catch (e) {
      console.log('!!!!Error', e)
    }
  }

  useEffect(() => {
    callPackageData()
  }, [])

  return (
    <div>
      <ListPackageData />
    </div>
  )
}

const ListWraper: FC = () => {
  const intl = useIntl()

  return (
    <div>
      <PageTitle
        breadcrumbs={[
          {
            title: 'list',
            path: '/packages/list',
            isActive: true,
            isSeparator: false,
          },
          {
            title: 'list',
            path: '/packages/list',
            isActive: true,
            isSeparator: true,
          },
        ]}
      >
        {intl.formatMessage({id: 'MENU.PACKAGE'})}
      </PageTitle>
      <ListPage />
    </div>
  )
}

export {ListWraper}
